// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2b9Kj","buttons":"styles_buttons__1PTlK"};